import { Crumblist, ICrumb, ISelectOption, Select, ThresholdPill } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import styled from 'styled-components';
import { Col3Col9, CrumblistContainer } from '.';

export const InstructionContainer = styled.div`
	margin-bottom: 20px;
`;
export interface ICol3Col9SelectCrumbProps {
	label: string;
	instructions: string;
	placeHolderText: string;
	availableItems: ISelectOption[];
	selectedItems: string[];
	crumbs: ICrumb[];
	onSelectedChange: (items: string[]) => void;
}

export class Col3Col9SelectWithCrumb extends React.PureComponent<ICol3Col9SelectCrumbProps> {
	public constructor(props: ICol3Col9SelectCrumbProps) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handleUpdateCrumbs = this.handleUpdateCrumbs.bind(this);
	}

	public render() {
		const { label, instructions, placeHolderText, selectedItems, availableItems, crumbs } = this.props;

		return (
			<Col3Col9 label={label} subLabelDisplayData={<ThresholdPill count={crumbs.length} />}>
				<div>
					<InstructionContainer>{instructions}</InstructionContainer>
					<Select
						items={availableItems}
						disabled={availableItems.length === 0}
						size='md'
						selectSize='xlg'
						dropdownSize='sm'
						onApply={this.handleChange}
						multiple={true}
						placeHolderText={placeHolderText}
						selectedValues={selectedItems}
					/>
					<CrumblistContainer>
						{crumbs.length > 0 && <Crumblist enableDismiss={true} data={crumbs} update={this.handleUpdateCrumbs} />}
					</CrumblistContainer>
				</div>
			</Col3Col9>
		);
	}

	public handleChange(values: string | string[] | undefined) {
		if (values === undefined) {
			const v: string[] = [];
			this.props.onSelectedChange(v);
		} else if (Array.isArray(values)) {
			this.props.onSelectedChange(values);
		} else {
			const v: string[] = [];
			v.push(values);
			this.props.onSelectedChange(v);
		}
	}

	public handleUpdateCrumbs(values: any[]) {
		const items = _.map(values, (crumb) => crumb.value);
		this.props.onSelectedChange(items);
	}
}
